import React, { useEffect, memo, Fragment, useState } from "react";
import { Row, Col, Dropdown, Button, Spinner, Tooltip, OverlayTrigger, Badge, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

//circular
import Circularprogressbar from "../../components/circularprogressbar.js";

// AOS
import AOS from "aos";
import "../../../node_modules/aos/dist/aos";
import "../../../node_modules/aos/dist/aos.css";
//apexcharts
import Chart from "react-apexcharts";


//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import avatar1 from "../../assets/images/avatars/01.png";

//Count-up
import CountUp from "react-countup";

// Redux Selector / Action
import { useSelector } from "react-redux";

// Import selectors & action from setting store
import * as SettingSelector from "../../store/setting/selectors";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { DEV_SERVER } from "../../constants/urls.js";
import { userSignal } from "../../signal/userSignal.js";
import { toast } from "react-toastify";
import { allUsersSignal } from "../../signal/allUsersSignal.js";
import DataTable from "react-data-table-component";

// install Swiper modules
// SwiperCore.use([Navigation]);

const Index = memo((props) => {
  useSelector(SettingSelector.theme_color);

  const graphOptions = {
    7: "Last 7 days",
    30: "Last 30 days",
    180: "Last 6 months",
    365: "Last 1 year",
  }

  let today = Date.now();
  today = new Date(today).setHours(0, 0, 0, 0);
  let fifteenDaysAgo = new Date(today - 15 * 24 * 60 * 60 * 1000).getTime();
  let fifteenDaysFuture = new Date(today + 15 * 24 * 60 * 60 * 1000).setHours(23, 59, 59, 999);
  // get today's end time in milliseconds
  let todayEndTime = new Date(today).setHours(23, 59, 59, 999);

  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const navigate = useNavigate();

  const colors = [variableColors.primary, variableColors.info];

  const [fromDate, setFromDate] = useState(7);
  const [orgGraphData, setOrgGraphData] = useState({});
  const [expenses, setExpenses] = useState([]);
  const [periodicExpenses, setPeriodicExpenses] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [trips, setTrips] = useState([]);


  const [organisationData, setOrganisationData] = useState({
    "totalFarmer": 0,
    "totalSuggestion": 0,
    "totalEmployee": 0,
    "totalExpense": 0
  });


  useEffect(() => {
    return () => colors;
  });

  const getExpenses = useQuery("expenses", async () => {
    const response = await axios.get(`${DEV_SERVER}/expense/v2?status=pending`, {
      headers: {
        Authorization: `Bearer ${userSignal.value?.token}`,
      }
    })
    return response.data;
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data.status) {

        let temp = data.data;
        let stateName = window.localStorage.getItem("state");
        if (stateName) {
          // temp = data.data.filter((item) => {
          //   return allUsersSignal.value[item?.userId?.length ? item?.userId[0]?.id : ""]?.state === stateName
          // })
        }

        setExpenses(temp);
      }
    },
    onError: (error) => {
      console.log(error);
    }
  })

  const getPeriodicExpenses = useQuery("periodicExpenses", async () => {
    const response = await axios.get(`${DEV_SERVER}/expense/v2/periodicExpenses`, {
      headers: {
        Authorization: `Bearer ${userSignal.value?.token}`,
      }
    })
    return response.data;
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data.status) {
        setPeriodicExpenses(data.data);
        let totalExpense = 0;
        data.data.map((item) => {
          totalExpense += item.amount;
        })
        setOrganisationData((prev) => ({ ...prev, totalExpense: prev.totalExpense + totalExpense }));
      }
    },
    onError: (error) => {
      console.log(error);
    }
  })

  const updateExpenseStatusMutation = useMutation((data) => axios.post(`${DEV_SERVER}/expense/v2/updateStatus/${data.id}`, data.body, {
    headers: {
      Authorization: `Bearer ${userSignal.value?.token}`,
    }
  }), {
    onSuccess: (resp) => {
      resp = resp.data;
      if (resp.status) {
        toast.success(resp.message);
        let temp = expenses
        temp = temp.filter((item) => item.id !== resp.data.id);
        setExpenses(temp);
      } else {
        toast.error(resp.message);
      }
    },
    onError: (error) => {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  })

  const handleExpenseStatus = (id, status) => {
    updateExpenseStatusMutation.mutate({ id, body: { status } });
  }

  const getOrgGraphData = useQuery("orgGraphData", async () => {
    const response = await axios.get(`${DEV_SERVER}/analysis/v2/organisation-home-graph?startTime=${new Date(today - fromDate * 24 * 60 * 60 * 1000).getTime()}&endTime=${todayEndTime}`, {
      headers: {
        Authorization: `Bearer ${userSignal.value?.token}`,
      }
    })
    return response.data;
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data.status) {
        let temp = {}
        data.data.map((item) => {
          if (item.totalExpense !== 0 || item.totalFarmers !== 0) {
            if (temp[moment(item._id).format("DD/MM/YY")]) {
              temp[moment(item._id).format("DD/MM/YY")].totalExpense += item.totalExpense;
              temp[moment(item._id).format("DD/MM/YY")].totalFarmer += item.totalFarmers;
            } else {
              temp[moment(item._id).format("DD/MM/YY")] = {
                totalExpense: item.totalExpense,
                totalFarmer: item.totalFarmers
              }
            }
          }
        })
        setOrgGraphData(temp);
      }
    },
    onError: (error) => {
      console.log(error);
    }
  })

  const getLeaves = useQuery("leaves", async () => {
    // Convert milliseconds to seconds for backend
    const startTimeSeconds = Math.floor(fifteenDaysAgo / 1000);
    const endTimeSeconds = Math.floor(fifteenDaysFuture / 1000);

    const response = await axios.get(
      `${DEV_SERVER}/leave/v2?status=pending&startTime=${startTimeSeconds}&endTime=${endTimeSeconds}`,
      {
        headers: {
          Authorization: `Bearer ${userSignal.value?.token}`,
        }
      }
    );
    return response.data;
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data.status) {
        let stateName = window.localStorage.getItem("state");
        let temp = data.data;
        if (stateName) {
          temp = data.data.filter((item) => {
            return allUsersSignal.value[item?.userId?.length ? item?.userId[0]?.id : ""]?.state === stateName
          });
        }
        setLeaves(temp);
      }
    },
    onError: (error) => {
      console.log(error);
    }
  })

  const getOrganisationData = useQuery("organisationData", async () => {
    const response = await axios.get(`${DEV_SERVER}/analysis/v2/organisation`, {
      headers: {
        Authorization: `Bearer ${userSignal.value?.token}`,
      }
    })
    return response.data;
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data.status) {
        setOrganisationData((prev) => ({ ...prev, ...data.data, totalExpense: prev.totalExpense + data?.data?.totalExpense }));
      }
    },
    onError: (error) => {
      console.log(error);
    }
  })

  const updateLeaveStatusMutation = useMutation((data) => axios.put(`${DEV_SERVER}/leave/v2/updateLeaveStatus/${data.id}`, data.body, {
    headers: {
      Authorization: `Bearer ${userSignal.value?.token}`,
    }
  }), {
    onSuccess: (resp) => {
      resp = resp.data;
      if (resp.status) {
        toast.success(resp.message);
        let temp = leaves
        temp = temp.filter((item) => item.id !== resp.data.id);
        setLeaves(temp);
      } else {
        toast.error(resp.message);
      }
    },
    onError: (error) => {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  })

  const getTrips = useQuery("trips", async () => {
    const response = await axios.get(`${DEV_SERVER}/trip/v2?perPage=35&startTime=${today}&endTime=${today + 86400000 - 1}&status=started`, {
      headers: {
        Authorization: `Bearer ${userSignal.value?.token}`,
      }
    })
    return response.data;
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data.status) {

        let temp = data.data.trips;
        let stateName = window.localStorage.getItem("state");
        if (stateName) {
          temp = data.data.trips.filter((item) => {
            return allUsersSignal.value[item?.userId]?.state === stateName
          })
        }

        setTrips(temp);
      }
    },
    onError: (error) => {
      console.log(error);
    }
  })

  const handleLeaveStatus = (id, status) => {
    updateLeaveStatusMutation.mutate({ id, body: { status } });
  }

  useEffect(() => {
    getOrgGraphData.refetch({ cancelRefetch: true });
  }, [fromDate])

  useEffect(() => {
    getOrganisationData.refetch({ cancelRefetch: true });
    getExpenses.refetch({ cancelRefetch: true });
    getLeaves.refetch({ cancelRefetch: true });
    getOrgGraphData.refetch({ cancelRefetch: true });
    getTrips.refetch({ cancelRefetch: true });
    getPeriodicExpenses.refetch({ cancelRefetch: true });
  }, [])

  useEffect(() => {
    AOS.init({
      startEvent: "DOMContentLoaded",
      disable: function () {
        var maxWidth = 996;
        return window.innerWidth < maxWidth;
      },
      throttleDelay: 10,
      once: true,
      duration: 700,
      offset: 10,
    });
  });
  const chart1 = {
    options: {
      chart: {
        fontFamily:
          '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: false,
        },
      },
      colors: colors,
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      yaxis: {
        show: true,
        labels: {
          show: true,
          minWidth: 19,
          // maxWidth: 19,
          style: {
            colors: "#8A92A6",
          },
          offsetX: -5,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        labels: {
          minHeight: 22,
          maxHeight: 22,
          show: true,
          style: {
            colors: "#8A92A6",
          },
        },
        lines: {
          show: false, //or just here to disable only x axis grids
        },
        // type: "datetime",
        // categories: orgGraphData.map((item) => item._id),
      },
      grid: {
        show: false,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 50, 80],
          colors: colors,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    series: [
      {
        name: "Total Expense in thousands",
        data: Object.keys(orgGraphData).map((item) => ({ x: item, y: (orgGraphData[item].totalExpense / 1000).toFixed(2) }))
      },
      {
        name: "Total New Farmers",
        data: Object.keys(orgGraphData).map((item) => ({ x: item, y: orgGraphData[item].totalFarmer }))
      },
    ],
  };

  const tripColumns = [
    {
      name: "Date",
      sortable: true,
      center: true,
      selector: "date",
      cell: (row) => {
        return <span>{moment(row?.date).format("DD/MM/YYYY")}</span>
      }
    },
    {
      name: "User",
      selector: (row) => {
        if (allUsersSignal.value?.[row?.userId]) {
          return (
            <div className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
              <img
                style={{ width: "20px", height: "20px" }}
                src={allUsersSignal.value?.[row?.userId]?.profileURL !== "" ? allUsersSignal.value?.[row?.userId]?.profileURL : avatar1}
                className="rounded-circle avatar-xs"
                alt="friend"
              />
              <OverlayTrigger placement="top" overlay={
                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                  {allUsersSignal.value?.[row?.userId]?.name}
                </Tooltip>}>
                <span style={{ width: "100%" }}>{allUsersSignal.value?.[row?.userId]?.name}</span>
              </OverlayTrigger>
            </div>
          )
        }
        return "-"
      }
    },
    {
      name: "Status",
      center: true,
      selector: (row) => {
        if (!row?.isStarted) {
          return <Badge bg="info" text="white">Scheduled</Badge>
        }
        else if (!row?.isCompleted) {
          // if row.Date is less than today's date then it is overdue
          if (moment().startOf('day').valueOf() !== row?.date) {
            return <Badge bg="danger" text="white">Not Ended</Badge>
          }
          return <Badge bg="warning" text="white">On Going</Badge>
        }
        else {
          if (row?.isNotEnded) {
            return <Badge bg="danger" text="white">Not Ended</Badge>
          }
          return <Badge bg="success" text="white">Completed</Badge>
        }
      }
    },
    {
      name: "StartTime",
      center: true,
      selector: "startTime",
      cell: (row) => {
        if (row?.isStarted) {
          return <OverlayTrigger placement="top" overlay={
            <Tooltip style={{ position: "fixed" }} id="tooltip-top">
              {`${parseFloat(row?.startKM).toFixed(2)} km`}
            </Tooltip>}>


            <span className="d-flex flex-column align-items-center" style={{ rowGap: "0.5rem" }}>

              <span className="d-flex align-items-center">
                {parseFloat(row?.startKM) > 0 && `${parseFloat(row?.startKM).toFixed(2)} km`}

                {row?.startImage !== "" && <Zoom>
                  <i className="fa fa-spinner position-relative" style={{ cursor: "pointer", marginLeft: "0.5rem" }}></i>

                  <img src={row?.startImage} className="position-absolute" onLoad={(e) => {
                    e.target.style.pointerEvents = "unset"
                    let icon = e.target.previousSibling
                    icon.classList.remove("fa-spinner")
                    icon.classList.add("fa-eye")
                  }} width={700} height={700} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", top: "0%", left: "45%", opacity: "0", cursor: "pointer", borderRadius: "10px" }} />
                </Zoom>}
              </span>
              <p className="m-0">{moment(row?.startTime).format("hh:mm A")}</p>
            </span>
          </OverlayTrigger>

        }
        return "-"

      },
      sortable: true,
    },
    {
      name: "New Customers",
      center: true,
      selector: (row) => row?.totalNewCustomers,
      sortable: true,
    },
    {
      name: "Expense",
      center: true,
      selector: "totalExpense",
      cell: (row) => `${parseFloat(row?.totalExpense).toFixed(2)} Rs`,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => {
        return (
          <Link
            to={`/dashboard/trips/${row.id || row._id}`}
            className="text-primary"
          >
            View
          </Link>
        );
      }
    }
  ]


  return (
    <Fragment>
      <Row>
        <Col md="12" lg="12">
          <Row className="row-cols-1">
            <div className="overflow-hidden d-slider1 " data-aos="fade-up" data-aos-delay="800">
              {(!getOrganisationData.isLoading && !getOrganisationData?.isFetching) && <Swiper
                className="p-0 m-0 mb-2 list-inline "
                slidesPerView={5}
                spaceBetween={32}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  550: { slidesPerView: 2 },
                  991: { slidesPerView: 3 },
                  1400: { slidesPerView: 3 },
                  1500: { slidesPerView: 4 },
                  1920: { slidesPerView: 4 },
                  2040: { slidesPerView: 7 },
                  2440: { slidesPerView: 8 }
                }}

              >
                <SwiperSlide style={{ cursor: "pointer" }} onClick={() => navigate("/dashboard/farmers")} className="card card-slide" >
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        Linecap="rounded"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        style={{ width: 60, height: 60 }}
                        value={90}
                        id="circle-progress-01"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Farmers</p>
                        <h4 className="counter">
                          <CountUp start={0} end={parseInt(organisationData?.totalFarmer)} />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ cursor: "pointer" }} onClick={() => navigate("/dashboard/users")} className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={60}
                        id="circle-progress-02"
                      >
                        <svg
                          className=""
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Employees</p>
                        <h4 className="counter">
                          <CountUp start={0} end={parseInt(organisationData.totalEmployee)} />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ cursor: "pointer" }} onClick={() => navigate("/dashboard/expenses")} className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.primary}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={70}
                        id="circle-progress-03"
                      >
                        <svg className="" width="24" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Expense</p>
                        <h4 className="counter">
                          ₹ {organisationData.totalExpense > 1000 ? (organisationData.totalExpense / 1000).toFixed(2) + "K" : parseFloat(organisationData.totalExpense).toFixed(2)}
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ cursor: "pointer" }} onClick={() => navigate("/dashboard/suggestions")} className=" card card-slide">
                  <div className="card-body">
                    <div className="progress-widget">
                      <Circularprogressbar
                        stroke={variableColors.info}
                        width="60px"
                        height="60px"
                        trailstroke="#ddd"
                        strokewidth="4px"
                        Linecap="rounded"
                        style={{ width: 60, height: 60 }}
                        value={60}
                        id="circle-progress-04"
                      >
                        <svg
                          className=""
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                          />
                        </svg>
                      </Circularprogressbar>
                      <div className="progress-detail">
                        <p className="mb-2">Total Suggestions</p>
                        <h4 className="counter">
                          <CountUp start={0} end={parseInt(organisationData.totalSuggestion)} />
                        </h4>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <div className="swiper-button swiper-button-next"></div>
                <div className="swiper-button swiper-button-prev"></div>
              </Swiper>}
            </div>
          </Row>
        </Col>
        <Col md="12" lg="8">
          <Row>
            <Col md="12">
              <div className="card" data-aos="fade-up" data-aos-delay="800">
                <div className="flex-wrap card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Expense & New Farmers</h4>
                    {/* <p className="mb-0">Gross Sales</p> */}
                  </div>
                  <div className="d-flex align-items-center align-self-center">
                    <div className="d-flex align-items-center text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <g>
                          <circle
                            cx="12"
                            cy="12"
                            r="8"
                            fill="currentColor"
                          ></circle>
                        </g>
                      </svg>
                      <div className="ms-2">
                        <span className="text-gray">Expense</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center ms-3 text-info">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <g>
                          <circle
                            cx="12"
                            cy="12"
                            r="8"
                            fill="currentColor"
                          ></circle>
                        </g>
                      </svg>
                      <div className="ms-2">
                        <span className="text-gray">New Farmers</span>
                      </div>
                    </div>
                  </div>
                  <Dropdown>
                    <Dropdown.Toggle
                      as={Button}
                      variant="text-gray"
                      type="button"
                      id="dropdownMenuButtonSM"
                    // onClick={(e) => setFromDate(e.target.value)}
                    >
                      {graphOptions[fromDate]}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {Object.keys(graphOptions).map((item, index) => (
                        <Dropdown.Item key={index} onClick={() => setFromDate(item)}>{graphOptions[item]}</Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="card-body">
                  {chart1?.series?.length && <Chart
                    options={chart1.options}
                    series={chart1.series}
                    type="area"
                    height="245"
                  />}

                </div>
              </div>
            </Col>
            <Col md="12" lg="12">
              <Card data-aos="fade-up" data-aos-delay="800">
                <Card.Header className="d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Today's Ongoing Trips</h4>
                  </div>
                </Card.Header>
                <Card.Body>
                  {(!getTrips.isLoading && !getTrips?.isFetching) && <DataTable
                    className="w-100"
                    onRowClicked={(row) => navigate(`/dashboard/trips/${row?.id}`)}
                    customStyles={{
                      rows: {
                        style: {
                          cursor: "pointer",
                          backgroundColor: "unset"
                        }
                      }
                    }}
                    columns={tripColumns}
                    pagination={true}
                    data={trips}
                    paginationPerPage={35}
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                  />}
                  {(getTrips.isLoading || getTrips?.isFetching) && <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  }
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col md="12" lg="4">
          <Row>
            <Col md="12" lg="12">

              <div className="card" data-aos="fade-up" data-aos-delay="500" style={{ position: "relative" }}>
                {updateExpenseStatusMutation.isLoading && <div style={{ backgroundColor: "rgba(0,0,0,0.1)", borderRadius: "inherit", display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", width: "100%", height: "100%", zIndex: "1000" }}>
                  <Spinner animation="grow" variant="warning" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0.5rem" }}>
                  <h6>Pending Expenses</h6>
                  <Link to={"/dashboard/expenses"} style={{ textDecoration: "none !important", color: "child" }}><span>View All <svg width="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 5L15.5 12L8.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></Link>
                </div>
                <div style={{ display: "flex", flexDirection: "column", padding: "0.8rem", rowGap: "1rem" }} >


                  {(getExpenses.isLoading || getExpenses?.isFetching) ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><Spinner animation="grow" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner></div>
                    :
                    <>
                      {expenses?.length === 0 && <p style={{ textAlign: "center" }}>No pending expenses</p>}
                      {expenses?.slice(0, 10).map((expense) =>
                        <Row key={expense?.id} style={{ display: "flex" }}>
                          <Col lg="7" style={{ display: "flex", alignItems: "start", columnGap: "0.7rem" }}>
                            <img width={"50px"} height={"50px"} style={{ borderRadius: "50%" }} src={expense?.userId?.length > 0 ? (expense?.userId[0].profileURL !== "" ? expense?.userId[0].profileURL : avatar1) : avatar1} />
                            <span style={{ display: "flex", flexDirection: "column" }}>
                              <span style={{ fontSize: "1rem" }}><b>{expense?.userId?.length > 0 ? expense?.userId[0].name : ""}</b></span>
                              <p style={{ fontSize: "0.7rem" }}>{`${expense?.title} - ${expense?.description}`}</p>
                            </span>
                          </Col>
                          <Col lg="3" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                            <p style={{ fontSize: "0.8rem", margin: "0px" }}>{moment(expense?.createdAt).format("DD/MM/YY")}</p>
                            <p style={{ margin: "0px" }}>₹ {parseFloat(expense?.amount).toFixed(2)}</p>
                          </Col>

                          <Col lg="2" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", columnGap: "0.8rem" }}>
                            <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={() => handleExpenseStatus(expense?.id, "rejected")} style={{ cursor: "pointer", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={() => handleExpenseStatus(expense?.id, "approved")} style={{ cursor: "pointer", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
                          </Col>
                        </Row>
                      )}
                    </>}
                </div>
              </div>
            </Col>
            <Col md="12" lg="12">

              <div className="card" data-aos="fade-up" data-aos-delay="500" style={{ position: "relative" }}>
                {updateLeaveStatusMutation.isLoading && <div style={{ backgroundColor: "rgba(0,0,0,0.1)", borderRadius: "inherit", display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", width: "100%", height: "100%", zIndex: "1000" }}>
                  <Spinner animation="grow" variant="warning" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0.5rem" }}>
                  <h6>Pending Leaves</h6>
                  <Link to={"/dashboard/leaves"} style={{ textDecoration: "none !important", color: "child" }}><span>View All <svg width="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 5L15.5 12L8.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></Link>
                </div>
                <div style={{ display: "flex", flexDirection: "column", padding: "0.8rem", rowGap: "1rem" }} >


                  {(getLeaves.isLoading || getLeaves?.isFetching) ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><Spinner animation="grow" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner></div>
                    :
                    <>
                      {leaves?.length === 0 && <p style={{ textAlign: "center" }}>No pending leaves</p>}
                      {leaves?.slice(0, 10).map((leave) =>
                        <Row key={leave?.id} style={{ display: "flex" }}>
                          <Col lg="7" style={{ display: "flex", alignItems: "flex-start", columnGap: "0.7rem" }}>
                            <img width={"50px"} height={"50px"} style={{ borderRadius: "50%" }} src={leave?.userId?.length > 0 ? (leave?.userId[0].profileURL !== "" ? leave?.userId[0].profileURL : avatar1) : avatar1} />
                            <span style={{ display: "flex", flexDirection: "column" }}>
                              <span style={{ fontSize: "1rem" }}><b>{leave?.userId?.length > 0 ? leave?.userId[0].name : ""}</b></span>
                              <p style={{ fontSize: "0.7rem" }}>{`${leave?.reason}`}</p>
                            </span>
                          </Col>
                          <Col lg="3" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", rowGap: "0.2rem" }}>
                            <p style={{ fontSize: "0.8rem", margin: "0px" }}>{moment(leave?.startTime * 1000).format("DD/MM/YY hh:mm")}</p>
                            <span style={{ height: "5px", width: "1px", backgroundColor: "black" }}></span>
                            <p style={{ fontSize: "0.8rem", margin: "0px" }}>{moment(leave?.endTime * 1000).format("DD/MM/YY hh:mm")}</p>
                          </Col>

                          <Col lg="2" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", columnGap: "0.8rem" }}>
                            <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={() => handleLeaveStatus(leave?.id, "rejected")} style={{ cursor: "pointer", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={() => handleLeaveStatus(leave?.id, "approved")} style={{ cursor: "pointer", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
                          </Col>
                        </Row>
                      )}
                    </>}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
})

export default Index